import React, { Fragment, useState } from "react";
import plus from "../../../../assets/icons/plus.svg";
import info from "../../../../assets/icons/info-circle-white.svg";
import threeDots from "../../../../assets/icons/three-dots.svg";
import deleteIcon from "../../../../assets/icons/delete.png";
import { calledFromEnums, categories, commonFieldOptionEnums, fieldNameEnums, stepFieldConfig } from "../apiPageHelper";
import FormField from "../../../common/forms/FormField";
import ValidationChecks from "./ValidationChecks";
import ArrayFields from "./ArrayFields";

export default function StepForm({
    step,
    stepIndex,
    addField,
    updateField,
    getFieldsByCategory,
    removeField,
    removeStep,
    updateStepField,
    handleOpenAuthModal,
    authOptions,
    handleOpenConnectedFieldModal,
    setShowApiPageSidePanel,
    inputFields,
    outputFields,
    setSelectedCategory,
    setAuthorizationFieldsData,
    updateArraySubField,
    removeArraySubField
}) {
    // #region STATES
    const [showMenu, setShowMenu] = useState({
        stepMenu: false,
        fieldMenu: false,
        id: null
    });
    const [dataTypes] = useState([
        { value: "String", name: "String" },
        { value: "Number", name: "Number" },
        {
            value: "Boolean",
            name: "Boolean"
        },
        {
            value: "Array Fields",
            name: "Array Fields"
        }
    ]);
    // #endregion
    return (
        <div className="frame-276">
            <div className="frame-295">
                <div className="store-delivery-option-card">
                    <div className="frame-1000011391">
                        <div className="frame-1000011229">
                            <div className="frame-1000011443">
                                <div className="frame-161">
                                    <div className="frame-296">
                                        <div className="step-1">STEP {stepIndex + 1}</div>
                                        <img className="info-circle" src={info} alt="" />
                                    </div>
                                    {stepIndex !== 0 && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                setShowMenu(prev => {
                                                    const { stepMenu, ...rest } = prev;
                                                    return {
                                                        ...rest,
                                                        stepMenu: !stepMenu
                                                    };
                                                })
                                            }>
                                            <img className="trash-01" src={threeDots} alt="" />
                                            {showMenu?.stepMenu && (
                                                <div
                                                    className="p-absolute"
                                                    style={{
                                                        position: "absolute",
                                                        right: "0",
                                                        border: "1px solid #3c485a",
                                                        zIndex: 1000
                                                    }}>
                                                    <div
                                                        className="table-list-action-dropdown"
                                                        onClick={() => removeStep(stepIndex)}>
                                                        <div className="frame-74">
                                                            <div className="align-items-center justify-center gap-4px p-4px">
                                                                <img
                                                                    className="trash-01"
                                                                    src={deleteIcon}
                                                                    alt=""
                                                                    height={"20px"}
                                                                />
                                                                <div className="remove text-white">Remove Step</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="frame-1000011228">
                                    <div className="frame-1000011227">
                                        {stepFieldConfig?.map((field, index) => {
                                            return field?.type === "dropdown" ? (
                                                <div key={index} className="flex">
                                                    <FormField
                                                        className="w-100"
                                                        type="dropdown"
                                                        title={field.label}
                                                        tooltip={field.label}
                                                        dropdownData={(field.dynamic
                                                            ? authOptions
                                                            : field.options
                                                        )?.map(option => ({
                                                            value: option,
                                                            name: option
                                                        }))}
                                                        value={step[field.key]}
                                                        requiredType={"mandatory"}
                                                        assistiveText=""
                                                        varName="type"
                                                        onTextChange={e => {
                                                            const selected = e.value;
                                                            if (
                                                                field.key === "auth" &&
                                                                selected === commonFieldOptionEnums.CREATE_NEW
                                                            ) {
                                                                handleOpenAuthModal();
                                                                return;
                                                            }
                                                            updateStepField(stepIndex, field.key, selected);
                                                            setAuthorizationFieldsData(prev => ({
                                                                ...prev,
                                                                authName: selected
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <React.Fragment key={index}>
                                                    <FormField
                                                        type="text"
                                                        title="URL"
                                                        tooltip="URL"
                                                        requiredType="mandatory"
                                                        placeholder="https://"
                                                        assistiveText=""
                                                        varName="url"
                                                        value={step[field.key]}
                                                        onTextChange={e => updateStepField(stepIndex, field.key, e)}
                                                    />
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="line-4"></div>
                        <div className="frame-1000011390">
                            {Object.entries(categories).map(([category, label], index) => {
                                const fields = getFieldsByCategory(step, category);
                                const sourceFields =
                                    category === "returnFields" ? outputFields || [] : inputFields || [];

                                const recommendedFieldsToShow = sourceFields
                                    ?.filter(f => f.isRecommended)
                                    ?.map(field => ({
                                        ...field,
                                        selected: fields?.some(f => f.value === field.value)
                                    }));

                                const mandatoryFieldsToShow = sourceFields
                                    ?.filter(f => f.isMandatory)
                                    ?.map(field => ({
                                        ...field,
                                        selected: fields.some(f => f.value === field.value)
                                    }));

                                const allFieldsSelected = mandatoryFieldsToShow
                                    ?.filter(f => f.isMandatory)
                                    .every(f => f.selected === true);
                                return (
                                    <div className="frame-1000011384" key={index}>
                                        <div className="frame-1000011382">
                                            <div className="frame-295922385">
                                                <div className="frame-295922380">
                                                    <div className="frame-161">
                                                        <div className="frame-296">
                                                            <div className="header-fields">{label}</div>
                                                            <img className="info-circle9" src={info} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="frame-2959223813">
                                                    <div className="frame-271">
                                                        <div className="frame-291">
                                                            <div className="frame-171">
                                                                <div className="frame-144"></div>
                                                            </div>
                                                        </div>
                                                        <div className="frame-1588">
                                                            {fields?.map((field, index) => {
                                                                const mergedOptions = [
                                                                    ...(inputFields?.map(f => ({
                                                                        value: f.value,
                                                                        name: f.value
                                                                    })) || []),
                                                                    ...(outputFields?.map(f => ({
                                                                        value: f.value,
                                                                        name: f.value
                                                                    })) || []),
                                                                    ...(field?.options?.filter(
                                                                        opt =>
                                                                            opt?.label !==
                                                                            commonFieldOptionEnums.CONNECTED
                                                                    ) || [])
                                                                ];

                                                                const uniqueOptions = Array.from(
                                                                    new Map(
                                                                        mergedOptions.map(opt => [opt.value, opt])
                                                                    ).values()
                                                                );
                                                                return (
                                                                    <Fragment key={field.id || index}>
                                                                        <div
                                                                            className={`${
                                                                                field?.value === "Predefined"
                                                                                    ? "frame-902"
                                                                                    : "frame-901"
                                                                            } p-relative`}>
                                                                            <div className="dropdown-selector2">
                                                                                <FormField
                                                                                    type="dropdown"
                                                                                    title="Type"
                                                                                    tooltip="Type"
                                                                                    dropdownData={dataTypes}
                                                                                    value={field.type}
                                                                                    requiredType={"mandatory"}
                                                                                    assistiveText=""
                                                                                    varName="type"
                                                                                    onTextChange={e =>
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            "type",
                                                                                            e?.value
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <div className="simple">
                                                                                <FormField
                                                                                    type="text"
                                                                                    title="Name"
                                                                                    tooltip="Name"
                                                                                    requiredType={"mandatory"}
                                                                                    assistiveText=""
                                                                                    varName="name"
                                                                                    value={field?.name}
                                                                                    onTextChange={e =>
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            "name",
                                                                                            e
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <div className="dropdown-selector2">
                                                                                <FormField
                                                                                    className="w-100"
                                                                                    type="dropdown"
                                                                                    title="Value"
                                                                                    tooltip="Value"
                                                                                    dropdownData={uniqueOptions}
                                                                                    dropdownSettings={{
                                                                                        hasLockedFields: true
                                                                                    }}
                                                                                    requiredType="mandatory"
                                                                                    assistiveText=""
                                                                                    varName="value"
                                                                                    value={field.value}
                                                                                    onTextChange={e => {
                                                                                        const selectedValue = e?.value;
                                                                                        const isCreateNewConnectField =
                                                                                            selectedValue ===
                                                                                            commonFieldOptionEnums.CONNECTED;
                                                                                        const isPredefined =
                                                                                            selectedValue ===
                                                                                            commonFieldOptionEnums.PREDEFINED;

                                                                                        if (isCreateNewConnectField) {
                                                                                            handleOpenConnectedFieldModal();
                                                                                            updateField(
                                                                                                stepIndex,
                                                                                                field.id,
                                                                                                "value",
                                                                                                undefined,
                                                                                                "",
                                                                                                true
                                                                                            );
                                                                                            return;
                                                                                        }

                                                                                        if (isPredefined) {
                                                                                            updateField(
                                                                                                stepIndex,
                                                                                                field.id,
                                                                                                "value",
                                                                                                selectedValue,
                                                                                                undefined,
                                                                                                true
                                                                                            );
                                                                                            return;
                                                                                        }

                                                                                        let key =
                                                                                            fieldNameEnums.CONNECTED_FIELD;
                                                                                        if (
                                                                                            inputFields?.some(
                                                                                                f =>
                                                                                                    f.value ===
                                                                                                    selectedValue
                                                                                            )
                                                                                        ) {
                                                                                            key =
                                                                                                fieldNameEnums.EXTRA_FIELD;
                                                                                        } else if (
                                                                                            outputFields?.some(
                                                                                                f =>
                                                                                                    f.value ===
                                                                                                    selectedValue
                                                                                            )
                                                                                        ) {
                                                                                            key =
                                                                                                fieldNameEnums.RETURN_FIELD;
                                                                                        }
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            "value",
                                                                                            selectedValue,
                                                                                            key,
                                                                                            true
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            {field?.value ===
                                                                            commonFieldOptionEnums.PREDEFINED ? (
                                                                                <FormField
                                                                                    type="text"
                                                                                    title="Predefined Value"
                                                                                    tooltip="Predefined Value"
                                                                                    requiredType="mandatory"
                                                                                    assistiveText=""
                                                                                    varName="predefinedValue"
                                                                                    value={field?.predefinedValue}
                                                                                    onTextChange={e =>
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            fieldNameEnums.PREDEFINED_FIELD,
                                                                                            e,
                                                                                            fieldNameEnums.PREDEFINED_FIELD
                                                                                        )
                                                                                    }
                                                                                />
                                                                            ) : null}

                                                                            <div
                                                                                className="cursor-pointer p-absolute"
                                                                                style={{
                                                                                    right: "0px",
                                                                                    top: "19px",
                                                                                    padding: "2px",
                                                                                    color: "white"
                                                                                }}>
                                                                                <div>
                                                                                    <div
                                                                                        className="table-list-action-dropdown"
                                                                                        onClick={() =>
                                                                                            removeField(
                                                                                                stepIndex,
                                                                                                field.id
                                                                                            )
                                                                                        }>
                                                                                        <div className="frame-74">
                                                                                            <div className="align-items-center justify-center  p-4px">
                                                                                                <img
                                                                                                    className="trash-01"
                                                                                                    src={deleteIcon}
                                                                                                    alt=""
                                                                                                    height={"20px"}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {field.type === "Array Fields" && (
                                                                            <>
                                                                                {field?.arrayFields?.map(subField => {
                                                                                    return (
                                                                                        <ArrayFields
                                                                                            key={subField.id}
                                                                                            subField={subField}
                                                                                            stepIndex={stepIndex}
                                                                                            dataTypes={dataTypes}
                                                                                            updateArraySubField={
                                                                                                updateArraySubField
                                                                                            }
                                                                                            parentFieldId={field.id}
                                                                                            dropdownData={uniqueOptions}
                                                                                            parentField={field}
                                                                                            removeArraySubField={
                                                                                                removeArraySubField
                                                                                            }
                                                                                            handleOpenConnectedFieldModal={
                                                                                                handleOpenConnectedFieldModal
                                                                                            }
                                                                                            inputFields={inputFields}
                                                                                            outputFields={outputFields}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </>
                                                                        )}
                                                                    </Fragment>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="frame-1000011386">
                                                <div
                                                    className="btn-sm-special"
                                                    onClick={() =>
                                                        addField(stepIndex, category, calledFromEnums.API_PAGE)
                                                    }>
                                                    <img className="plus" src={plus} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <ValidationChecks
                                            handleSeeAllClick={() => {
                                                setShowApiPageSidePanel(true);
                                                setSelectedCategory({
                                                    category: category,
                                                    fields: { mandatoryFieldsToShow, recommendedFieldsToShow }
                                                });
                                            }}
                                            allFieldsSelected={allFieldsSelected}
                                            mandatoryFieldsToShow={mandatoryFieldsToShow}
                                            recommendedFieldsToShow={recommendedFieldsToShow}
                                        />
                                        <div className="line-4"></div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
